import React, {FC, useContext} from 'react';
import {
    DropDownV2Context,
    Flex,
    Icon,
    PriorityIcon,
    Text,
    TextColor
} from '@priority-software/priority-style-react';
import {texts} from '../../../../texts';
import styles from './styles.module.scss';

interface IColumnDropdownTrigger {
    disabledValues?: {
        disabled: boolean;
        color: TextColor;
        style: {cursor: 'pointer' | 'unset'};
    };
}

export const ColumnDropdownTrigger: FC<IColumnDropdownTrigger> = ({disabledValues}) => {
    const {toggleOpen} = useContext(DropDownV2Context);

    return (
        <Text
            onClick={() => {
                if (disabledValues.disabled) return;
                toggleOpen();
            }}
            componentClasses={styles.link}
            tag="div"
            skin="breadcrumb"
            textColor={disabledValues.color}
            style={{...disabledValues.style}}
        >
            <Flex justifyContent="flex-start" inline alignItems="center">
                {texts.input_field_label}
                <Icon iconColor={disabledValues.color} icon={PriorityIcon.arrowDown} />
            </Flex>
        </Text>
    );
};
